/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbQuerySyncLogResourceType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceNowCmdbQuerySyncLogResourceType");
    }

    getFixupPrototypeFunction() { return ServiceNowCmdbQuerySyncLogResourceType.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbQuerySyncLogResourceType>): ServiceNowCmdbQuerySyncLogResourceType {
        let obj = Object.assign(new ServiceNowCmdbQuerySyncLogResourceType(), model);
        ServiceNowCmdbQuerySyncLogResourceType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbQuerySyncLogResourceType>): ServiceNowCmdbQuerySyncLogResourceType {
        if (!model) return null;
        return ServiceNowCmdbQuerySyncLogResourceType.newInstance(<ServiceNowCmdbQuerySyncLogResourceType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbQuerySyncLogResourceType) {
        if (!obj) return;

        models.ServiceNowCmdbQuerySyncLogResourceType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbQuerySyncLogResourceType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbQuerySyncLogResourceType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Synchronized resource types
     */
    resource_types: Array<string>;

}
